/**
 * Veluna PDP offer - one plain, literally true discount offer on product pages.
 *
 * REBUILT 2026-09-23 (popup CRO pass). The previous version was a "mystery"
 * scratch card that said "a single discount, randomly assigned" while the
 * only prize configured was SLEEP10. It also auto-added the product to the
 * cart and redirected to checkout. All of that is gone:
 *   - no mystery / random framing, no scratch mechanic, no confetti
 *   - the offer is stated up front: 10% off a one-time order
 *   - the code is SHOWN, plainly, after the email is accepted (2xx only)
 *   - nothing is added to the cart and nobody is redirected anywhere
 *
 * SLEEP10 as configured in Shopify admin (checked 2026-09-23): 10% off
 * one-time purchase products, not subscriptions, one use per customer, does
 * not combine with other discounts. The legal line below says exactly that.
 * The code and percent still come from the pdp-mystery-popup section settings.
 *
 * Trigger: 30 s on the page or 50% scroll, whichever comes first, and only
 * when VelunaCaptureGuard allows it (never over the buy box, never after an
 * add-to-cart this session, never after a capture). Any dismissal suppresses
 * it for 7 days and for the rest of the session.
 *
 * The file name and the section are unchanged so rollback is one asset.
 * The legacy checkout interceptor below is kept ONLY for visitors who already
 * hold a code from the old flow (veluna_pdp_mystery_won); new signups never
 * write that key.
 */
(function () {
  'use strict';

  var cfgEl = document.getElementById('veluna-pdp-mystery-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (_) { return; }
  if (!CFG || !CFG.product) return;

  var OFFER = (CFG.prizes || []).filter(function (p) { return p && p.code && p.percent > 0; })[0] || null;

  var STORAGE = {
    legacyWon: 'veluna_pdp_mystery_won',
    offer: 'veluna_pdp_offer_code',
    dismissedUntil: 'veluna_pdp_offer_dismissed_until',
    sessionDismissed: 'veluna_pdp_offer_dismissed_session',
    captured: 'veluna_email_captured'
  };
  var SUPPRESS_MS = 7 * 24 * 60 * 60 * 1000;
  var DWELL_MS = 30000;
  var SCROLL_FRACTION = 0.5;
  var CAPTURE_ID = 'pdp-mystery';

  try {
    if (/\/products\//.test(window.location.pathname)) {
      (window.__vlnPageSpecific = window.__vlnPageSpecific || []).push(CAPTURE_ID);
      window.VelunaCaptureGuard && window.VelunaCaptureGuard.registerPageSpecific(CAPTURE_ID);
    }
  } catch (e) {}

  var BACKEND = {
    url: 'https://ary09mimgg.execute-api.us-east-2.amazonaws.com/Prod/subscribe',
    sequence: 'pdp_offer',
    popupVariant: 'pdp_offer_v2',
    source: 'veluna_pdp_offer'
  };

  /* Product handle -> concern code. Sets first, then the specific products.
     sleep-plus-collagen-cream must be tested before the generic collagen rule. */
  var CONCERN_NAMES = { mc: 'Mind Calm', dr: 'Deep Restore', ss: 'Sacred Soothe' };
  function concernFor(handle) {
    var h = String(handle || '').toLowerCase();
    if (h.indexOf('mind-calm') !== -1) return 'mc';
    if (h.indexOf('deep-restore') !== -1) return 'dr';
    if (h.indexOf('sacred-soothe') !== -1) return 'ss';
    if (/hyaluronic|sleep-plus|gummies/.test(h)) return 'ss';
    if (/recovery-cream|collagen/.test(h)) return 'dr';
    if (/sleep-formula|magnesium-glycinate|ashwagandha|sleep-strips/.test(h)) return 'mc';
    return '';
  }
  var CONCERN = concernFor(CFG.product.handle);

  function ls(k) { try { return localStorage.getItem(k); } catch (_) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (_) {} }
  function ssGet(k) { try { return sessionStorage.getItem(k); } catch (_) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (_) {} }
  function esc(s) { var d = document.createElement('div'); d.textContent = String(s == null ? '' : s); return d.innerHTML; }

  function isCaptured() {
    return ls(STORAGE.captured) === 'true' || !!ls('veluna_pdf_captured') || !!ls(STORAGE.offer) ||
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((ls('veluna_quiz_email') || '').trim());
  }
  function isDismissed() {
    if (ssGet(STORAGE.sessionDismissed)) return true;
    var until = parseInt(ls(STORAGE.dismissedUntil) || '0', 10);
    return !!until && Date.now() < until;
  }
  function hasLegacyWin() { return !!ls(STORAGE.legacyWon); }

  function fireLead(p) {
    try { if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', p); } catch (_) {}
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'generate_lead', source: p.source, concern: p.concern, surface: p.surface }); } catch (_) {}
  }
  function push(ev, extra) {
    try {
      if (!window.dataLayer) return;
      var o = { event: ev, product_handle: CFG.product.handle };
      for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) o[k] = extra[k];
      window.dataLayer.push(o);
    } catch (_) {}
  }

  /* ---------- styles (unquoted font stacks: this CSS lives in a JS string) ---------- */
  function injectStyles() {
    if (document.getElementById('vpm-styles')) return;
    var css = [
      '.vpm__overlay{position:fixed;inset:0;z-index:2147483000;background:rgba(10,8,6,.72);display:flex;align-items:center;justify-content:center;padding:16px;opacity:0;transition:opacity .25s ease;}',
      '.vpm__overlay.is-open{opacity:1;}',
      '.vpm__card{position:relative;width:100%;max-width:440px;max-height:92vh;overflow-y:auto;background:#17120E;color:#F5F2EB;padding:12px;box-shadow:0 24px 60px rgba(0,0,0,.45);transform:translateY(10px);transition:transform .25s ease;}',
      '.vpm__overlay.is-open .vpm__card{transform:none;}',
      '.vpm__frame{border:1px solid rgba(245,194,107,.45);padding:32px 26px 22px;text-align:center;}',
      '.vpm__close{position:absolute;top:18px;right:18px;background:transparent;border:0;cursor:pointer;padding:8px;color:#B9B0A2;line-height:0;}',
      '.vpm__close:hover{color:#F5F2EB;}',
      '.vpm__brand{margin:0;font-family:var(--veluna-ui,Hanken Grotesk,Arial,sans-serif);font-weight:600;font-size:12px;letter-spacing:.3em;text-transform:uppercase;color:#F5C26B;}',
      '.vpm__h{margin:16px 0 0;font-family:var(--veluna-serif,Newsreader,Georgia,serif);font-weight:400;font-size:29px;line-height:1.12;color:#F5F2EB!important;text-wrap:balance;}',
      '.vpm__sub{margin:12px auto 18px;max-width:36ch;font-family:var(--veluna-ui,Hanken Grotesk,Arial,sans-serif);font-size:14px;line-height:1.55;color:#E8DDD0;}',
      '.vpm__form{display:flex;flex-direction:column;gap:10px;text-align:left;}',
      '.vpm__label{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;}',
      '.vpm__input{width:100%;min-height:48px;padding:0 14px;border:1px solid rgba(245,242,235,.35);background:rgba(245,242,235,.06);color:#F5F2EB;border-radius:4px;font-family:var(--veluna-ui,Hanken Grotesk,Arial,sans-serif);font-size:16px;box-sizing:border-box;}',
      '.vpm__input::placeholder{color:#8F877A;}',
      '.vpm__btn{display:flex;align-items:center;justify-content:center;width:100%;min-height:48px;background:#F5C26B;color:#1F1A16;border:0;border-radius:4px;padding:12px 18px;font-family:var(--veluna-ui,Hanken Grotesk,Arial,sans-serif);font-size:15px;font-weight:600;cursor:pointer;text-decoration:none;box-sizing:border-box;}',
      '.vpm__btn:hover{background:#F8D08A;}',
      '.vpm__btn[disabled]{opacity:.6;cursor:wait;}',
      '.vpm__error{min-height:18px;margin:0;font-family:var(--veluna-ui,Hanken Grotesk,Arial,sans-serif);font-size:13px;color:#F5C26B;}',
      '.vpm__legal{margin:12px 0 0;font-family:var(--veluna-ui,Hanken Grotesk,Arial,sans-serif);font-size:12px;line-height:1.5;color:#B9B0A2;}',
      '.vpm__skip{display:block;margin:12px auto 0;background:transparent;border:0;padding:8px;cursor:pointer;font-family:var(--veluna-ui,Hanken Grotesk,Arial,sans-serif);font-size:13px;color:#B9B0A2;text-decoration:underline;}',
      '.vpm__code{display:block;margin:6px auto 4px;padding:14px 12px;border:1px dashed rgba(245,194,107,.7);font-family:var(--veluna-mono,DM Mono,ui-monospace,monospace);font-size:28px;letter-spacing:.16em;color:#F5C26B;user-select:all;-webkit-user-select:all;}',
      '.vpm__copied{min-height:18px;margin:6px 0 10px;font-family:var(--veluna-ui,Hanken Grotesk,Arial,sans-serif);font-size:13px;color:#E8DDD0;}',
      '.vpm__close:focus-visible,.vpm__btn:focus-visible,.vpm__skip:focus-visible,.vpm__input:focus{outline:2px solid #F5C26B;outline-offset:2px;}',
      '@media (max-width:480px){.vpm__frame{padding:28px 16px 18px;}.vpm__h{font-size:25px;}}',
      '@media (prefers-reduced-motion:reduce){.vpm__overlay,.vpm__card{transition:none;}}'
    ].join('');
    var s = document.createElement('style');
    s.id = 'vpm-styles';
    s.textContent = css;
    document.head.appendChild(s);
  }

  /* ---------- views ---------- */
  function legalLine() {
    return 'One use per customer. Applies to one-time purchases, not subscriptions. ' +
      'Cannot be combined with other discounts. No spam, unsubscribe anytime.';
  }
  function viewOffer() {
    return '' +
      '<p class="vpm__brand">Veluna Sleep</p>' +
      '<h2 class="vpm__h" id="vpm-title">' + esc(OFFER.percent) + '% off your next one-time order</h2>' +
      '<p class="vpm__sub">Enter your email and your code appears here, ready to use at checkout.</p>' +
      '<form class="vpm__form" data-form novalidate>' +
        '<label class="vpm__label" for="vpm-email">Email address</label>' +
        '<input class="vpm__input" id="vpm-email" type="email" name="email" placeholder="Your email" required autocomplete="email" />' +
        '<button class="vpm__btn" type="submit" data-submit>Show my code</button>' +
        '<p class="vpm__error" data-error role="status" aria-live="polite"></p>' +
      '</form>' +
      '<p class="vpm__legal">' + esc(legalLine()) + '</p>' +
      '<button class="vpm__skip" type="button" data-skip>No thanks</button>';
  }
  function viewCode() {
    return '' +
      '<p class="vpm__brand">Your code</p>' +
      '<h2 class="vpm__h" id="vpm-title">' + esc(OFFER.percent) + '% off a one-time order</h2>' +
      '<p class="vpm__sub">Enter this code at checkout. It is not applied automatically.</p>' +
      '<span class="vpm__code" data-code>' + esc(OFFER.code) + '</span>' +
      '<p class="vpm__copied" data-copied role="status" aria-live="polite"></p>' +
      '<button class="vpm__btn" type="button" data-copy>Copy code</button>' +
      '<p class="vpm__legal">' + esc(legalLine().replace(' No spam, unsubscribe anytime.', '')) + '</p>' +
      '<button class="vpm__skip" type="button" data-done>Back to the product</button>';
  }

  /* ---------- build / open / close ---------- */
  var overlay = null, isOpen = false, releaseFocus = null, shownOnce = false;

  function render(html) { overlay.querySelector('[data-body]').innerHTML = html; }

  function build() {
    if (overlay) return overlay;
    injectStyles();
    overlay = document.createElement('div');
    overlay.className = 'vpm__overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'vpm-title');
    overlay.setAttribute('data-capture-id', CAPTURE_ID);
    overlay.innerHTML = '<div class="vpm__card"><button class="vpm__close" type="button" data-close aria-label="Close">' +
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
      '</button><div class="vpm__frame" data-body></div></div>';
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) { close('backdrop'); return; }
      if (e.target.closest('[data-close]')) { close('close-btn'); return; }
      if (e.target.closest('[data-skip]')) { close('skip'); return; }
      if (e.target.closest('[data-done]')) { close('done'); return; }
      if (e.target.closest('[data-copy]')) { copyCode(); }
    });
    overlay.addEventListener('submit', function (e) {
      if (e.target.matches('[data-form]')) { e.preventDefault(); onEmailSubmit(e.target); }
    });
    document.addEventListener('keydown', function (e) {
      if (isOpen && (e.key === 'Escape' || e.key === 'Esc')) close('esc');
    });
    document.body.appendChild(overlay);
    return overlay;
  }

  function open(reason) {
    if (!shouldShow()) return;
    build();
    render(viewOffer());
    isOpen = true;
    shownOnce = true;
    try { window.VelunaCaptureGuard && window.VelunaCaptureGuard.notifyOpen(CAPTURE_ID); } catch (_) {}
    requestAnimationFrame(function () { if (overlay) overlay.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
    try {
      var G = window.VelunaCaptureGuard;
      releaseFocus = G && G.holdFocus ? G.holdFocus(overlay, { initial: '#vpm-email' }) : null;
    } catch (_) { releaseFocus = null; }
    push('veluna_pdp_offer_shown', { trigger: reason, offer_percent: OFFER.percent });
  }

  function close(reason) {
    if (!overlay || !isOpen) return;
    isOpen = false;
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    try { window.VelunaCaptureGuard && window.VelunaCaptureGuard.notifyClosed(CAPTURE_ID); } catch (_) {}
    if (!isCaptured()) {
      lsSet(STORAGE.dismissedUntil, String(Date.now() + SUPPRESS_MS));
      ssSet(STORAGE.sessionDismissed, '1');
      try { window.VelunaCaptureGuard && window.VelunaCaptureGuard.notifyDismissed && window.VelunaCaptureGuard.notifyDismissed(CAPTURE_ID); } catch (_) {}
    }
    if (releaseFocus) { try { releaseFocus(); } catch (_) {} releaseFocus = null; }
    var el = overlay;
    setTimeout(function () { if (el && el.parentNode) el.parentNode.removeChild(el); if (overlay === el) overlay = null; }, 260);
    push('veluna_pdp_offer_closed', { reason: reason });
  }

  function copyCode() {
    var note = overlay && overlay.querySelector('[data-copied]');
    function ok() { if (note) note.textContent = 'Copied. Paste it into the discount box at checkout.'; }
    function fail() { if (note) note.textContent = 'Select the code above to copy it.'; }
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(OFFER.code).then(ok, fail); return; }
    } catch (_) {}
    fail();
  }

  function onEmailSubmit(form) {
    var input = form.querySelector('input[type="email"]');
    var errEl = form.querySelector('[data-error]');
    var btn = form.querySelector('[data-submit]');
    var email = (input.value || '').trim();
    errEl.textContent = '';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { errEl.textContent = 'Please enter a full email address.'; input.focus(); return; }
    btn.disabled = true; btn.textContent = 'Sending…';
    submitToBackend(email).then(function (res) {
      if (!res || !res.ok) throw new Error('subscribe_failed');
      lsSet(STORAGE.captured, 'true');
      lsSet('veluna_pdf_captured', email + '|' + Date.now());
      lsSet(STORAGE.offer, JSON.stringify({ code: OFFER.code, percent: OFFER.percent, ts: Date.now(), product: CFG.product.handle }));
      fireLead({ source: BACKEND.source, concern: CONCERN, surface: 'pdp' });
      push('veluna_lead_captured', { source: BACKEND.source, concern: CONCERN, offer_percent: OFFER.percent });
      render(viewCode());
      setTimeout(function () { var b = overlay && overlay.querySelector('[data-copy]'); if (b) { try { b.focus({ preventScroll: true }); } catch (_) {} } }, 40);
    }).catch(function () {
      errEl.textContent = 'That did not go through. Please try again.';
      btn.disabled = false; btn.textContent = 'Show my code';
    });
  }

  function submitToBackend(email) {
    var tags = [BACKEND.source, 'pdp_' + (CFG.product.handle || 'unknown'), BACKEND.sequence];
    if (CONCERN) tags.push('concern_' + CONCERN);
    var body = {
      email: email,
      topic: 'popup_subscribe',
      first_name: '',
      source: BACKEND.source,
      email_sequence: BACKEND.sequence,
      popup_variant: BACKEND.popupVariant,
      tags: tags,
      fields: {
        sleep_concern: CONCERN,
        ritual_type: CONCERN ? CONCERN_NAMES[CONCERN] : '',
        email_sequence: BACKEND.sequence,
        popup_variant: BACKEND.popupVariant,
        discount_code: OFFER.code,
        discount_percent: OFFER.percent,
        product_handle: CFG.product.handle,
        product_title: CFG.product.title,
        product_url: CFG.product.url
      },
      metadata: { page: window.location.pathname, referrer: document.referrer || '',
                  user_agent: (navigator && navigator.userAgent) || '' }
    };
    /* Top-level concern routes the welcome email. Omitted when the product
       maps to none, so the engine applies its own default. */
    if (CONCERN) body.concern = CONCERN;
    return fetch(BACKEND.url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).catch(function () { return null; });
  }

  /* ---------- triggers ---------- */
  var PREVIEW = /[?&]popup_preview=1\b/.test(window.location.search);
  /* An exit (pointer leaving the window) may open while the buy box is on
     screen; every other guard rule still applies. 2026-09-29. */
  var EXITING = false;
  function guardAllows(id) {
    var G = window.VelunaCaptureGuard;
    if (!G) return true;
    var r = G.reason ? G.reason(id) : (G.mayShow(id) ? null : 'blocked');
    return r === null || (EXITING && r === 'commerce_configuration_visible');
  }
  function shouldShow() {
    if (isOpen || !OFFER) return false;
    if (PREVIEW) return true;
    if (shownOnce) return false;
    if (hasLegacyWin() || isCaptured() || isDismissed()) return false;
    if (!guardAllows(CAPTURE_ID)) return false;
    return true;
  }

  function installTriggers() {
    var loadedAt = Date.now(), armed = false, poll = null;
    function scrolledHalf() {
      var doc = document.documentElement;
      var max = doc.scrollHeight - doc.clientHeight;
      return max > 0 && (window.scrollY || doc.scrollTop || 0) / max >= SCROLL_FRACTION;
    }
    function attempt(reason) {
      if (!armed) {
        if (Date.now() - loadedAt >= DWELL_MS) armed = 'dwell';
        else if (scrolledHalf()) armed = 'scroll-depth';
        else return;
      }
      if (shownOnce || isDismissed() || isCaptured()) { stop(); return; }
      if (shouldShow()) { stop(); open(reason || armed); }
    }
    function onScroll() { attempt(); }
    function stop() {
      window.removeEventListener('scroll', onScroll);
      if (poll) { clearInterval(poll); poll = null; }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    /* Exit intent, desktop only (2026-09-29): the pointer leaves through the
       top after 5 s on the page. */
    if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      document.addEventListener('mouseout', function (e) {
        if (e.relatedTarget || e.clientY >= 80 || Date.now() - loadedAt < 5000) return;
        if (shownOnce || isDismissed() || isCaptured()) return;
        EXITING = true;
        try { if (shouldShow()) { stop(); open('exit-intent'); } } finally { EXITING = false; }
      });
    }
    /* Once the 30 s have passed, keep checking gently: the guard refuses while
       the buy box is on screen, so the offer waits for the visitor to move on. */
    setTimeout(function () { attempt('dwell'); if (!shownOnce && !poll) poll = setInterval(function () { attempt(); }, 2000); }, DWELL_MS);
  }

  /* ---------- legacy holders of an old scratch-card code ---------- */
  function getLegacyPrize() {
    try { var d = JSON.parse(ls(STORAGE.legacyWon) || 'null'); return (d && d.code) ? d : null; } catch (_) { return null; }
  }
  function installLegacyCheckoutInterceptor() {
    if (window.__velunaCheckoutInterceptorInstalled) return;
    window.__velunaCheckoutInterceptorInstalled = true;
    document.addEventListener('click', function (e) {
      var prize = getLegacyPrize();
      if (!prize) return;
      var t = e.target && e.target.closest && e.target.closest('a[href*="/checkout"], a[href*="/cart/checkout"], button[name="checkout"], [data-checkout-button], [data-action="checkout"]');
      if (!t || t.getAttribute('data-veluna-discount-applied') === '1') return;
      e.preventDefault();
      e.stopPropagation();
      t.setAttribute('data-veluna-discount-applied', '1');
      var target = (t.tagName === 'A' && t.getAttribute('href')) ? t.getAttribute('href') : '/checkout';
      window.location.href = '/discount/' + encodeURIComponent(prize.code) + '?redirect=' + encodeURIComponent(target);
    }, true);
  }

  function init() {
    if (hasLegacyWin()) { installLegacyCheckoutInterceptor(); return; }
    if (!OFFER) return;
    if (PREVIEW) { setTimeout(function () { open('preview'); }, 800); return; }
    if (isCaptured() || isDismissed()) return;
    installTriggers();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* QA helper: opens the offer regardless of storage (does not submit anything). */
  window.__velunaMysteryTest = function () {
    try {
      localStorage.removeItem(STORAGE.dismissedUntil); sessionStorage.removeItem(STORAGE.sessionDismissed);
    } catch (_) {}
    shownOnce = false;
    if (!isOpen && OFFER) { var saved = PREVIEW; PREVIEW = true; open('manual-test'); PREVIEW = saved; }
  };
})();
